<section>
  <div style="margin: 20px">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
            (click)="setPeriod('1')" checked />
          <label class="form-check-label" for="flexRadioDefault3"> Anual </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
            (click)="setPeriod('2')" />
          <label class="form-check-label" for="flexRadioDefault2">
            Mensual
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
            (click)="setPeriod('3')" />
          <label class="form-check-label" for="flexRadioDefault1">
            Semanal
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
            (click)="setPeriod('4')" />
          <label class="form-check-label" for="flexRadioDefault4"> Diario </label>
        </div>
        <div *ngIf="contractMode" class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
            (click)="setPeriod('5')" />
          <label class="form-check-label" for="flexRadioDefault4"> Todos </label>
        </div>
      </div>

      <!-- Botones de exportación -->
      <div *ngIf="contractMode" class="export-buttons-container">
        <button type="button"
                class="btn export-btn"
                [class.active]="selectedExportType === 'csv'"
                (click)="openExportDropdown('csv')"
                [disabled]="isExporting">
          <i class="fas fa-file-csv me-1"></i>
          CSV
        </button>
        <button type="button"
                class="btn export-btn"
                [class.active]="selectedExportType === 'excel'"
                (click)="openExportDropdown('excel')"
                [disabled]="isExporting">
          <i class="fas fa-file-excel me-1"></i>
          Excel
        </button>

        <!-- Dropdown de selección de alcance -->
        <div class="export-dropdown-container"
             *ngIf="showExportDropdown"
             [style.position]="'absolute'"
             [style.top]="'100%'"
             [style.right]="'0'"
             [style.z-index]="'1000'"
             [style.margin-top]="'8px'">
          <div class="export-dropdown">
            <div class="export-option"
                 [class.active]="selectedScope === 'current'"
                 (click)="onScopeSelect('current')">
              <div class="option-content">
                <div class="option-title">Exportar vista</div>
                <div class="option-subtitle">Solo los movimientos visibles en esta página</div>
              </div>
            </div>

            <div class="export-option"
                 [class.active]="selectedScope === 'all'"
                 (click)="onScopeSelect('all')">
              <div class="option-content">
                <div class="option-title">Exportar todo</div>
                <div class="option-subtitle">Todos los movimientos que cumplen los filtros</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!contractMode" style="margin-left: auto;">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="flexRadioCurrency" id="flexRadioCurrencyPesos"
          (click)="setCurrency(1)" checked />
        <label class="form-check-label" for="flexRadioCurrencyPesos"> Pesos </label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="flexRadioCurrency" id="flexRadioCurrencyDolares"
          (click)="setCurrency(2)" />
        <label class="form-check-label" for="flexRadioCurrencyDolares"> Dolares </label>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!emptyTable; else Norows">
    <table class="table">
      <thead>
        <tr>
          <!-- <th scope="col">#</th> -->
          <th scope="col">{{ "Movimientos" }}</th>
          <th scope="col">{{ "header.accountPartial" | translate }}</th>
          <th scope="col">{{ "header.description" | translate }}</th>
          <!-- <th scope="col">{{'header.referenceId' | translate}}</th> -->
          <th scope="col">{{ "Fecha movimientos" | translate }}</th>
          <th scope="col">{{ "header.movementType" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="fila-hover" *ngFor="let accountMovement of accountMovements; index as i" (click)="
            redirect(
              accountMovement.referenceId,
              movementTypes(accountMovement.movementType)
            )
          " [ngbTooltip]="'Ver más'" style="cursor: pointer">
          <!-- <td>{{ i + 1 }}</td> -->
          <td class="money" [ngClass]="{
              rojo: accountMovement.amount < 0,
              verde: accountMovement.amount > 0
            }">
            {{ accountMovement.amount | currency:
            (currencyVal === 2 ? 'USD' : 'ARS') : (currencyVal === 2 ?
            'symbol'
            :
            'symbol-narrow') : '1.0-0' }}
          </td>
          <td class="money" [ngClass]="{
              rojo: accountMovement.partialAccount < 0,
              verde: accountMovement.partialAccount > 0
            }">
            {{ accountMovement.partialAccount | currency:
            (currencyVal === 2 ? 'USD' : 'ARS') : (currencyVal === 2 ?
            'symbol'
            :
            'symbol-narrow') : '1.0-0' }}
          </td>
          <td>{{ accountMovement.description || "-" }}</td>
          <td>
            {{
            dateService.transformToDateStringFromString(accountMovement.date)
            }}
          </td>
          <td>{{ movementTypes(accountMovement.movementType) | translate }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</section>
<!-- Paginator  -->
<div *ngIf="!emptyTable" class="paginator-component">
  <ngb-pagination (pageChange)="pageChanged($event)" [(page)]="page" [pageSize]="itemsPerPage"
    [collectionSize]="totalItems" [boundaryLinks]="true" [maxSize]="5">
    <ng-template ngbPaginationPrevious>Ant</ng-template>
    <ng-template ngbPaginationNext>Sig</ng-template>
  </ngb-pagination>
</div>
<!-- /Paginator  -->
<ng-template #Norows>
  <div class="norows">
    <fa-icon style="margin-bottom: 5px" [icon]="iconQuestion" size="2x"></fa-icon>
    <span>{{ "gridComponent.tableEmpty" | translate }}</span>
  </div>
</ng-template>